customElements.get('monogram-options') ||
  customElements.define(
    'monogram-options',
    class extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('.monogram-options__checkbox');
        this.fields = this.querySelector('[data-monogram-fields]');
        this.characters = this.querySelector('.monogram-options__text-input');
        this.colorInputs = Array.from(this.querySelectorAll('input[name="properties[Monogram Color]"]'));

        if (!this.toggle || !this.fields) return;

        this.toggle.addEventListener('change', () => this.updateState());
        this.characters?.addEventListener('input', (event) => {
          event.target.value = event.target.value.toUpperCase().slice(0, 3);
        });
        this.updateState();
      }

      get enabled() {
        return Boolean(this.toggle?.checked);
      }

      updateState() {
        const enabled = this.enabled;
        this.fields.hidden = !enabled;

        if (this.characters) {
          this.characters.disabled = !enabled;
          this.characters.required = enabled;
          if (!enabled) this.characters.value = '';
        }

        this.colorInputs.forEach((input) => {
          input.disabled = !enabled;
          input.required = enabled;
          if (!enabled) input.checked = false;
        });
      }

      validate() {
        if (!this.enabled) return true;

        const charactersValid = this.characters?.reportValidity() ?? true;
        const colorValid = this.colorInputs[0]?.reportValidity() ?? true;
        return charactersValid && colorValid;
      }
    }
  );
